import api from "./index";

// Pre-send safety runs (BE communications.presend): every bulk send is
// previewed, tested, approved by a second person when large, then sent slowly.

export const previewSendRun = (kind, params = {}, limit) =>
  api.post('/api/communications/send-runs/preview/', { kind, params, limit });

export const createSendRun = (kind, params = {}, { name, limit, submit = true } = {}) =>
  api.post('/api/communications/send-runs/', { kind, params, name, limit, submit });

export const getSendRuns = (params = {}) =>
  api.get('/api/communications/send-runs/', { params });

export const getSendRun = (id) =>
  api.get(`/api/communications/send-runs/${id}/`);

export const getSendRunRecipients = (id, params = {}) =>
  api.get(`/api/communications/send-runs/${id}/recipients/`, { params });

export const exportSendRun = (id) =>
  api.get(`/api/communications/send-runs/${id}/export/`, { responseType: 'blob' });

// action = submit | test-send | approve | reject | pause | resume | cancel | rebuild | retry-failed
export const sendRunAction = (id, action, data = {}) =>
  api.post(`/api/communications/send-runs/${id}/${action}/`, data);
